import validator from "email-validator";

const phoneNumber = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
// const email = /^[\w-.]+@([\w-]+\.)+[\w-]{2,12}$/;

export default {
  email(e) {
    // console.log("test " + e + email.test(e));
    return validator.validate(e);
  },
  phoneNumber(n) {
    if (n && n.length < 8) return false;
    return phoneNumber.test(n);
  },
  mobile(n) {
    if (!n) return false;
    const number = n
      //delete all non-digit except for +
      .replace(/[^\d+]/g, "")
      //replace leading 00
      .replace(/^00/, "+")
      //support incomplete numbers for common mistakes for Australian numbers.
      .replace(/^61/, "+61")
      .replace(/^6104/, "+614")
      //support for Chinese mainland as well.
      .replace(/^86/, "+86");

    return /^(04|\+614)\d{8}$/.test(number);
  }
};
